// Access to the meshlisted service: EasyMesh role (primary/secondary) of the
// routers of a few selected ISPs. The feature is enabled only when
// REACT_APP_MESHLISTED_URL is set and the current user's isp is served by
// the service (GET /config). REACT_APP_MESHLISTED_ISPS is an optional static
// list used when the service cannot be reached.
//
// It uses its own REST driver on purpose: src/backend comes from midgard and
// an error from this optional service (401/403/5xx) must never trigger the
// portal unauthorized handler nor pollute the backend cache.

import RestDriver from '../../backend/drivers/rest'
import { backendStatus } from '../../backend/backend'

export const meshRole = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    DISABLED: 'disabled',
}

export const meshRoleLabels = {
    [meshRole.PRIMARY]: 'Principal',
    [meshRole.SECONDARY]: 'Secundário',
    [meshRole.DISABLED]: 'Desativado',
}

const driver = new RestDriver(process.env.REACT_APP_MESHLISTED_URL)

function servedIsps() {
    return (process.env.REACT_APP_MESHLISTED_ISPS || '')
        .split(',')
        .map((isp) => isp.trim())
        .filter((isp) => isp !== '')
}

let servedIspsPromise = null

// Asks the service which ISPs it serves, once per page load. On failure
// falls back to the static env list (possibly empty).
function fetchServedIsps() {
    if (!servedIspsPromise) {
        servedIspsPromise = driver.retrieve('config', null)
            .then((result) => {
                const isps = result && result.status === backendStatus.SUCCESS && result.content
                    ? result.content.isps
                    : null

                return Array.isArray(isps) ? isps.map(String) : servedIsps()
            })
            .catch((error) => {
                console.warn('meshlisted config unavailable', error)
                servedIspsPromise = null
                return servedIsps()
            })
    }

    return servedIspsPromise
}

export async function isMeshlistedEnabled(user) {
    if (!process.env.REACT_APP_MESHLISTED_URL || !user || !user.ispid)
        return false

    const isps = await fetchServedIsps()

    return isps.includes(user.ispid)
}

// Returns { [deviceid]: {role, type, enabled, controller_ip, backhaul, updated_at} }.
// Devices the service has no data for are simply absent. Any failure yields
// an empty map so the listing keeps working without the column data.
export async function fetchMeshRoles(backend, deviceids) {
    const ids = (deviceids || []).filter((id) => !!id)

    if (ids.length === 0)
        return {}

    try {
        const result = await driver.retrieve(`devices/mesh?ids=${ids.join(',')}`, backend.auth)

        if (!result || result.status !== backendStatus.SUCCESS)
            return {}

        if (!result.content || typeof result.content !== 'object' || Array.isArray(result.content))
            return {}

        return result.content
    } catch (error) {
        console.warn('meshlisted unavailable', error)
        return {}
    }
}
